// extracted by mini-css-extract-plugin
export default {"close":"PollQuestionForm_close__LF9vF"};